// extracted by mini-css-extract-plugin
module.exports = {"avatar":"UploadView_avatar__3QNpt","view":"UploadView_view__1H2RE","view--secondary":"UploadView_view--secondary__2zE4n"};